import { Chip as UnstyledChip, styled } from "@mui/material";

export const Chip = styled(UnstyledChip)(({ theme }) => ({
  backgroundColor: theme.palette.info.light,
  "& .MuiChip-avatar": {
    color: theme.palette.info.main,
  },
}));
